import { Component, Input, OnInit } from "@angular/core";
import { DashboardMultiStationService } from "../dashboard-multistation.service";

@Component({
	selector: "caass-ms-todays-reasons",
	templateUrl: "./ms-todays-reasons.component.html",
	styleUrls: ["./ms-todays-reasons.component.css"],
})
export class MsTodaysReasonsComponent implements OnInit {
	constructor(private visitorService: DashboardMultiStationService) {}

	ngOnInit(): void {
		this.GenerateColors();
		this.loadData();
	}

	ngOnChanges() {
		this.loadData();
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	@Input() FacilityID: number = -1;

	loading: boolean = false;

	lstVisitorReason: any = [];
	chartData: any;
	lstBackgroundColors: string[] = [];
	lstHoverColors: string[] = [];
	OptionID: number = 0;
	Title: string = "Facility";

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////

	loadData() {
		this.ClearData();

		if (this.FacilityID == undefined || this.FacilityID < 0) {
			return;
		}

		this.loading = true;

		var result = this.visitorService.TodaysReasonsSelectList(this.OptionID == 0 ? this.FacilityID : -1);
		result.subscribe(
			(response: any) => {
				this.lstVisitorReason = response;

				this.UpdateChart();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	UpdateChart() {
		this.chartData = null;

		var lstLabels: string[] = [];
		var lstData: number[] = [];
		var lstBackgroundColor: string[] = [];
		var lstHoverBackgroundColor: string[] = [];

		for (var z = 0; z < this.lstVisitorReason.length; z++) {
			var next = this.lstVisitorReason[z];

			lstLabels = [...lstLabels, String(next.VisitorReasonDesc)];
			lstData = [...lstData, next.ReasonCount];

			lstBackgroundColor = [...lstBackgroundColor, this.GetNextBackgroundColor(next.VisitorReasonID)];
			lstHoverBackgroundColor = [...lstHoverBackgroundColor, this.GetNextHoverColor(next.VisitorReasonID)];
		}

		this.chartData = {
			labels: lstLabels,
			datasets: [
				{
					data: lstData,
					backgroundColor: lstBackgroundColor,
					hoverBackgroundColor: lstHoverBackgroundColor,
				},
			],
		};
	}

	GenerateColors() {
		this.lstBackgroundColors = [];
		this.lstHoverColors = [];

		for (var z = 0; z < 200; z++) {
			//Ex. hsl(360 100% 50%)
			var rand = Math.random() * 360;

			var nextBackground = "hsl(" + rand + " 85% 50%)";
			var nextHover = "hsl(" + rand + " 85% 25%)";
			this.lstBackgroundColors = [...this.lstBackgroundColors, nextBackground];
			this.lstHoverColors = [...this.lstHoverColors, nextHover];
		}
	}

	GetNextBackgroundColor(z) {
		return this.lstBackgroundColors[z % this.lstBackgroundColors.length];
	}

	GetNextHoverColor(z) {
		return this.lstHoverColors[z % this.lstHoverColors.length];
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////

	SelectOption(opt) {
		this.OptionID = opt;

		if (this.OptionID == 0) {
			this.Title = "Facility";
		} else if (this.OptionID == 1) {
			this.Title = "District";
		}

		this.loadData();
	}

	onRefreshColors() {
		this.GenerateColors();
		this.UpdateChart();
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////

	ClearData() {
		this.lstVisitorReason = [];
		this.chartData = null;
	}

	//////////////////////////////////////////////////////////
}
